export const config = {
  colours: ["red", "cyan", "yellow", "orange"],
  uidetails: {
    card: {
      windowTitle: "Edit Card",
    },
    logic: {
      windowTitle: "Edit Logic Block",
    },
    operator: {
      windowTitle: "Edit Operators",
    },
    detour: {
      windowTitle: "Edit Storylet Detour",
    },
    meta: {
      windowTitle: "Edit Meta",
    },
  },
  newStory: {
    info: {
      name: "",
      colour: "red",
    },
    cards: {
      start: {
        cardType: "basic",
        nodeType: "start",
        description: "",
        custom: [],
        tags: "",
        paragraphs: [],
        links: [
          {
            target: "start",
            linkText: "na",
            conditionAndOr: "and",
            conditions: [],
            actions: [],
          },
        ],
        editor: {
          left: 400,
          top: 0,
        },
      },
    },
  },
  newCard: {
    description: "",
    custom: [],
    paragraphs: [],
    nodeType: "card",
    links: [],
    editor: {
      left: 400,
      top: 200,
    },
  },
  newStartCard: {
    description: "Start",
    custom: [],
    tags: "",
    paragraphs: [],
    nodeType: "start",
    links: [
      {
        target: "start",
        linkText: "na",
        conditionAndOr: "and",
        conditions: [],
        actions: [],
      },
    ],
    editor: {
      left: 100,
      top: 200,
    },
  },
  newEndCard: {
    description: "End",
    custom: [],
    tags: "",
    paragraphs: [],
    nodeType: "end",
    prevStory: "",
    detourId: "",
    links: [
      {
        target: "end",
        linkText: "na",
        conditionAndOr: "and",
        conditions: [],
        actions: [],
      },
    ],
    editor: {
      left: 700,
      top: 200,
    },
  },
  newLogic: {
    nodeType: "logic",
    description: "Logic",
    custom: [],
    tags: "",
    links: [],
    editor: {
      left: 500,
      top: 360,
    },
  },
  newOperator: {
    nodeType: "operator",
    description: "Operator",
    custom: [],
    tags: "",
    links: [
      {
        target: "",
        linkText: "na",
        operations: [],
      },
    ],
    editor: {
      left: 500,
      top: 360,
    },
  },
  newMeta: {
    nodeType: "meta",
    description: "Meta",
    custom: [],
    tags: "",
    links: [
      {
        target: "",
        linkText: "na",
        operations: [],
      },
    ],
    editor: {
      left: 500,
      top: 360,
    },
  },
  newDetour: {
    nodeType: "detour",
    description: "Storylet",
    custom: [],
    tags: "",
    afterDetour: "",
    paragraphs: [],
    links: [
      {
        target: "",
      },
    ],
    detours: [
      {
        target: "main",
        linkText: "To the pear",
        conditionAndOr: "and",
        conditions: [],
        actions: [],
      },
    ],
    editor: {
      left: 500,
      top: 360,
    },
  },
  newNote: {
    nodeType: "note",
    text: "",
    editor: {
      left: 500,
      top: 360,
    },
  },
  newVariable: {
    type: "",
    enumValues: [],
    name: "",
    value: "",
  },
  nodeTypes: ["card", "detour", "logic", "operator", "start", "end", "meta", "note"],
};

export let editDefaults = {
  user: null,
  currentProjectId: null,
  currentProjectName: null,
  pendingStoryId: null,
  currentStorylet: null,
  currentLanguage: "en",
  editingCard: "none",
  canGoBack: false,
  previousEditingCard: "none",
  draggingCardAdd: "none",
  storyletsWindow: false,
  variablesWindow: false,
  languagesWindow: false,
  previewWindow: false,
  projectsWindow: false,
  helpWindow: false,
  settingsWindow: false,
  pointerX: 0,
  pointerY: 0,
  snapX: 0,
  snapY: 0,
  over: "none",
  cardsScale: 1,
  saving: false,
  selectedCards: [],
  selectionBox: { active: false, x: 0, y: 0, w: 0, h: 0 },
};
